import { render } from "./OurGovernance.vue?vue&type=template&id=7ead7970&scoped=true"
import script from "./OurGovernance.vue?vue&type=script&lang=js"
export * from "./OurGovernance.vue?vue&type=script&lang=js"

import "./OurGovernance.vue?vue&type=style&index=0&id=7ead7970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ead7970"]])

export default __exports__